export const ORDER_BOOK_HEADER_HEIGHT = 70;
export const ORDER_BOOK_ITEM_HEIGHT = 30;
